module.exports = __webpack_public_path__ + "img/vone-logo.d79c573d.png";